export enum VisitType {
  STORE = 'store',
  TAKEOUT = 'takeout',
}

export const VISIT_TYPE_NAMES: Record<VisitType, string> = {
  [VisitType.STORE]: '매장',
  [VisitType.TAKEOUT]: '포장 / 배달',
}

export const VISIT_TYPE_DISPLAY_LABELS: Record<VisitType, string> = {
  [VisitType.STORE]: '매장 이용',
  [VisitType.TAKEOUT]: '배달 및 포장',
}

export const getVisitTypeDisplayLabel = (visitType: VisitType): string => {
  return VISIT_TYPE_DISPLAY_LABELS[visitType]
}
